import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import teamStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/teamStyle.jsx";

function SectionTeam(props) {
  const { classes } = props;
  return (
    <div className={classes.team}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mrAuto,
            classes.mlAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>Hello from us!</h2>
          <h5 className={classes.description}>
            Curious about who some of our presenters and team are? Here is a
            little about us...
          </h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#natasha">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_natasha_munasinghe.jpeg"
                  alt="FRANK Team Natasha Munasinghe"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Natasha Munasinghe</h4>
              <h6 className={classes.textMuted}>
                CEO | Lawyer | Software Developer
              </h6>
              <p className={classes.cardDescription}>
                Disappointed her parents when she chose not pursue a legal
                career. Confused them even further when she learnt how to become
                a Software Developer. Luckily, developed a passion for
                Education. Very susceptible to good coffee
              </p>
            </CardBody>
            <CardFooter className={classes.justifyContent}>
              <Button
                href="https://www.linkedin.com/in/natashakhema/"
                justIcon
                simple
                color="linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in" />
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#amie">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_amie_morris.jpeg"
                  alt=" FRANK Team Amie Morris"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Amie Morris</h4>
              <h6 className={classes.textMuted}>
                Former TV Presenter & Media Personality
              </h6>
              <p className={classes.cardDescription}>
                Could write a volume of books from her time training politicians
                about how to present and communicate with the media. Has
                ridiculously good posture. Her passion is teaching seasoned
                professionals and young people how to communicate with
                confidence
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#melissa">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_melissa_abugazaleh.jpeg"
                  alt="FRANK Team Melissa Abu Gazaleh"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Melissa Abu Gazaleh</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Has won numerous awards including EY Social Entrepreneur of the
                Year & NSW Young Australian of the Year. Incredibly passionate
                about men's mental health and teaching people advocacy and
                community building skills
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#aaron">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_aaronngan.jpeg"
                  alt="FRANK Team Aaron Ngan"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Aaron Ngan</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Cannot walk down the street without meeting someone he knows.
                Has commiited his life to enabling people to become successful
                entrepreneurs & creating their own futures
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#malika">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_malika_krishnadasan.jpeg"
                  alt="FRANK Team Malika Krishnadasan"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Malika Krishnadasan</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Carved a remarkable and diverse career for herself from finance
                to change management working for companies like Microsoft,
                Medtronic and Canon Australia. Passionate about leadership and
                ensuring people work to their potential
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#sacha">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_sachakaluri.jpeg"
                  alt=" FRANK Team Sacha Kaluri"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Sacha Kaluri</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Has a store of energy that is hard to believe. From podcasts to
                TV and radio to presentng - Sacha is doing it all. Her passion
                is squarely on enabling young people to be their best
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#ivan">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/aboutus_ivan+chiew.jpeg"
                  alt="FRANK Team Ivan Chew"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Ivan Chew</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Specialised in workplace strategy and project management. He is
                studying his 5th degree and is pursuing his interest in
                psychology. You may also find him dabbling in improv and stand
                up comedy.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#silvia">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/about+us_silvia+deredder.jpg"
                  alt="FRANK Team Silvia de redder"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Silver de Redder</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Lives and breathes neuroscience. Her past experience as an
                engineer ensures she brings a very science based foundation to
                training and learning experiences.
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#sally">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/LogosSally.jpeg"
                  alt="FRANK Team Sally Herington"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Sally Hetherington OAM</h4>
              <h6 className={classes.textMuted}>Presenter</h6>
              <p className={classes.cardDescription}>
                Was awarded a Order of Australia Medal for her work building a
                community organisation in Cambodia. Passionate about creating
                meaningful and impactful change.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#fern">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/LogosFern.jpeg"
                  alt=" FRANK Team Fern Rice"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Fern Rice</h4>
              <h6 className={classes.textMuted}>
                Project Management & Administration
              </h6>
              <p className={classes.cardDescription}>
                Communicates with clients to ensure smooth project delivery and
                happy clients :)
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#jocelyn">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/LogosJocelyn.jpeg"
                  alt="FRANK Team Jocelyn Fernandez"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Jocelyn Fernandez</h4>
              <h6 className={classes.textMuted}>
                Project Management & Administration
              </h6>
              <p className={classes.cardDescription}>
                Manages key back-end tasks including video editing and digital
                work
              </p>
            </CardBody>
          </Card>
        </GridItem>
        {/* <GridItem md={3} sm={3}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#pablo">
                <img
                  src="https://frankteamwebsite.s3-ap-southeast-2.amazonaws.com/about+us_silvia+deredder.jpg"
                  alt="FRANK Team Ivan Chew"
                  className={classes.img}
                />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Shashinth Logeswaran</h4>
              <h6 className={classes.textMuted}>Editing & Digital</h6>
              <p className={classes.cardDescription}>
                Is our video and editing guru
              </p>
            </CardBody>
          </Card>
        </GridItem> */}
      </GridContainer>
    </div>
  );
}

export default withStyles(teamStyle)(SectionTeam);
